import script from "./AlbumCard.vue?vue&type=script&setup=true&lang=js"
export * from "./AlbumCard.vue?vue&type=script&setup=true&lang=js"

import "./AlbumCard.vue?vue&type=style&index=0&id=fb6d930c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb6d930c"]])

export default __exports__